import { Component, OnInit } from '@angular/core';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { CommonService } from "../../../common/common.service";
import { NgxSpinnerService } from "ngx-spinner";
import { HttpResponse } from "@angular/common/http";
import { PartnerService } from "../partner.service"
import Swal from "sweetalert2";
@Component({
  selector: 'app-edit-partner',
  templateUrl: './edit-partner.component.html',
  styleUrls: ['./edit-partner.component.css']
})
export class EditPartnerComponent implements OnInit {


  coursePlanResponse: any;
  partnerForm: FormGroup;
  formSubmitted: boolean = false;
  showDesciptionError: boolean = true;
  featureList = [];
  finalFeatureList = [];
  temp: any;
  desciptionName: string;
  partnerId: string;
  planRequest = {
    coursepartnerId: null,
    title: null,
    subTitle: null,
    price: null,
    featureList: [],
    sortOrder: null
  }
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

  constructor(
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private PlanService: PartnerService
  ) { }

  ngOnInit() {
    this.partnerId = this.route.snapshot.params["partnerId"];
    this.initialiseForms();
    this.getplanById();

  }

  getplanById() {
    this.spinner.show();
    let query = "partnerId=" + this.partnerId;
    this.PlanService.getplanListById(query).subscribe(res => {
      if ((res["status"] = "Success")) {
        this.coursePlanResponse = res.data.partnerList[0];
        this.updateForm();
        this.spinner.hide()
      } else {
        this.spinner.show()
        Swal.fire({
          type: "error",
          title: "Error",
          text: res.msg
        });
      }
    }, err => {
      this.spinner.hide();
    });

  }

  initialiseForms() {
    this.partnerForm = this.fb.group({
      name: ["", [Validators.required]],
      companyName: ["", [Validators.required]],
      mobile: ["", [Validators]],
      email:["", [Validators.required, Validators.pattern(this.emailPattern)]],
      address: [""],

    });
  }


  updateForm() {
    this.partnerForm.patchValue({
      name: this.coursePlanResponse["name"],
      companyName: this.coursePlanResponse["companyName"],
      mobile: this.coursePlanResponse["mobile"],
      email: this.coursePlanResponse["email"],
      address: this.coursePlanResponse["address"]
    });

  }





  Addplan() {
    this.formSubmitted = true;
    if (this.partnerForm.valid) {
      let request = this.partnerForm.value;
      request['partnerId'] = this.partnerId;
      request['mobile'] = request['mobile'].toString();
      this.PlanService.Editplan(request).subscribe(data => {
        if ((data["message"] = "Success")) {
          Swal.fire("Success", "Partner Updated Successfully!", "success");
          this.router.navigate(["/main/partner/view"]);
        } else {
          Swal.fire({
            type: "error",
            title: "Error",
            text: data.msg
          });
        }
      });
    }



  }

  cancel() {
    this.router.navigate(["/main/partner/view"]);
  }
}


